let children = [];
children.push({
    path: "/configuracion/circuitosaprobacion",
    name: "SEC_APPROBALCIRCUIT",
    component: () =>
        import("../views/Security/AutorizeModel.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Seguridad", disabled: true },
            { text: "Circuitos Aprobacion", href: "/configuracion/circuitosaprobacion" },
        ],
    },
});
children.push({
    path: "/configuracion/opcion",
    name: "SEC_OPTION",
    component: () =>
        import("../views/Security/Option.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Seguridad", disabled: true },
            { text: "Opción", href: "/configuracion/opcion" },
        ],
    },
});

children.push({
    path: "/configuracion/usuario",
    name: "SEC_USER",
    component: () =>
        import("../views/Security/UserOption.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "seguridad", disabled: true },
            { text: "usuarios", href: "/configuracion/usuario" },
        ],
    },
});
children.push({
    path: "/configuracion/usuario/asignaciones",
    name: "SEC_USER_ASSIGNMENT",
    component: () =>
        import("../views/Security/UserAssignment.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Seguridad", disabled: true },
            { text: "Usuarios a cargo", href: "/configuracion/usuario/asignaciones" },
        ],
        title: "SEC-Usuarios a cargo",
    },
});
children.push({
    path: "/seguridad/soporteTI",
    name: "RESOURCE_SUPPORT",
    component: () =>
        import("../views/Security/OtherSupport.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "seguridad", disabled: true },
            { text: "Soporte TI", href: "/seguridad/soporteTI" },
        ],
    },
});
children.push({
    path: "/seguridad/reconocimiento_facial",
    name: "SEC_FACIAL_RECOGNITION",
    component: () =>
        import("../views/Security/FacialRecognition.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Seguridad", disabled: true },
            { text: "Reconocimiento Facial", href: "/seguridad/reconocimiento_facial" },
        ],
    },
});
children.push({
    path: "/configuracion/aprobacionordenes",
    name: "SEC_APPROBAL_NOTIFICATION",
    component: () =>
        import("../views/Security/Approval/ApprovalOrder.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Seguridad", disabled: true },
            { text: "Aprobación Ordenes", href: "/configuracion/aprobacionordenes" },
        ],
    },
});
children.push({
    path: "/configuracion/aprobacion/requerimientos",
    name: "LGS_APPROVAL_REQUIREMENT",
    component: () =>
        import("../views/Security/Approval/ApprovalRequirement.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Seguridad", disabled: true },
            { text: "Aprobacion Req", href: "/configuracion/aprobacion/requerimientos" },
        ],
    },
});

children.push({
    path: "/configuracion/aprobacion/aprobaciones",
    name: "LGS_APPROVAL_LIST",
    component: () =>
        import("../views/Security/Approval/Approvals.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Seguridad", disabled: true },
            { text: "Aprobacion Req", href: "/configuracion/aprobacion/aprobaciones" },
        ],
    },
});

children.push({
    path: "/configuracion/notificaciones",
    name: "LGS_DESKTOP_NOTIFICATION",
    component: () =>
        import("../views/Security/Notification/SecDesktopNotification.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Seguridad", disabled: true },
            { text: "Aprobacion Req", href: "/configuracion/notificaciones" },
        ],
    },
});
children.push({
    path: "/seguridad/personalcriticidad",
    name: "PERCRITICAL",
    component: () =>
        import("../views/Security/UserCritical.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Seguridad", disabled: true },
            { text: "Personal Critico", href: "/seguridad/personalcriticidad" },
        ],
    },
});
children.push({
    path: "/seguridad/fotocheck-visita",
    name: "MNG_VISITOR_CARD",
    component: () =>
        import("../views/Management/visits/VisitorCardControl.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Seguridad", disabled: true },
            { text: "Fotocheck Visita", href: "/seguridad/fotocheck-visita" },
        ],
        title: "SEG-Fotocheck Visita",
    },
});
children.push({
    path: "/configuracion/aprobacion/adelanto-insumos",
    name: "SEC_APPROBAL_ADVANCE_PRODUCER",
    component: () =>
        import("../views/Security/Approval/ApprovalAdvanceProducer.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Seguridad", disabled: true },
            { text: "Aprobacion Insumos", href: "/configuracion/aprobacion/adelanto-insumos" },
        ],
    },
});
children.push({
    path: "/configuracion/aprobacion/seguimiento-adelanto-insumos",
    name: "SEC_APPROVAL_TRANSACTION_LIST",
    component: () =>
        import("../views/Security/Approval/ApprovalTrackingList.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Seguridad", disabled: true },
            { text: "Seguimiento Aprobacion Insumos", href: "/configuracion/aprobacion/seguimiento-adelanto-insumos" },
        ],
    },
});

export {
    children
}